<template>
    <div class="modal fade" id="campaignDetailsModal" ref="campaignDetailsModal" tabindex="-1" role="dialog" aria-labelledby="campaignDetailsModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="modal-title" id="campaignDetailsModalLabel">{{ $t('campaign_details.campaign_details_title') }}</h5>
                        </div>
                        <div class="col-12 mt-3">
                            <span class="detail-label">{{ $t('campaign_details.created_by') }}</span>&nbsp; <span class="detail-data canvassing-color-black">{{ campaign.owner_name }}</span>
                        </div>
                        <div class="col-12 mt-2">
                            <span class="detail-label">{{ $t('campaign_details.created_date') }}</span>&nbsp; <span class="detail-data canvassing-color-black">{{ parseDate(campaign.created_at) }}</span>
                        </div>
                        <div class="col-12 mt-2">
                            <span class="detail-label">{{ $t('campaign_details.campaign_status') }}</span>&nbsp; <span class="detail-data" :class="statusClass">{{ $t('campaign_teams.status.'+campaign.status) }}</span>
                        </div>
                        <div class="col-12 mt-2">
                            <span class="detail-label">{{ $t('campaign_details.role_in_campaign') }}</span>&nbsp; <span class="detail-data canvassing-color-black">{{ isOwner(campaign.owner_id) ? $t('campaign_details.owner') : $t('campaign_details.volunteer') }}</span>
                        </div>
                        <div v-if="!isOwner(campaign.owner_id)" class="col-12 mt-2" style="display: inherit;">
                            <span class="detail-label">{{ $t('campaign_details.status_in_campaign') }}</span>&nbsp; <span><div class="campaign-status mr-2" :class="campaign.user_status">{{ $t('campaign_teams.status.'+campaign.user_status) }}</div></span>
                        </div>
                        <div v-if="!isOwner(campaign.owner_id)" class="col-12 reject-text text-center mt-3 weight-500">
                            {{ typeof campaign.reject_message != 'undefined' ? campaign.reject_message : '' }}
                        </div>
                    </div>
                </div>
                <div v-if="!isOwner(campaign.owner_id)" class="modal-footer modal-footer-canvassing-redish">
                    <span @click="showExitCampaignModal" class="modal-footer-canvassing-red-button mt-3 mx-auto cursor-pointer">{{ $t('campaign_details.exit_campaign') }}</span>
                    <span class="note-text mx-auto mb-3">{{ $t('campaign_details.note') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "CampaignDetailsModal",
        props: ["campaign"],
        mixins: [HelperMixin],
        data() {
            return {
            }
        },
        created() {
                      
        },
        computed: {
            statusClass: function () {
                if (this.campaign.status == 'active') {
                    return {
                        'canvassing-color-green': this.campaign.status == 'active'
                    }
                } else {
                    return {
                        'canvassing-color-grey': this.campaign.status == 'inactive'
                    }
                }
                
            },

        },
        methods: {
            showExitCampaignModal() {
                this.dismissDetails();
                if (!this.$store.getters['online']) {
                    $('#featureUnavailableOfflineModal').modal('show');
                    return false;
                }
                $('#leaveCampaignModal').modal('show');
            },

            dismissDetails() {
                $('#campaignDetailsModal').modal('hide');
            },
        },
    };
</script>
